import { useAppDispatch, useAppSelector } from '~/store/hooks'
import { setActiveTool } from '~/store/tools'
import { Icon } from '~/ui/Icon'
import { ToggleButton } from '~/ui/ToggleButton'

export const SelectToolToggle = () => {
  const isSelectTool = useAppSelector(state => state.tools.activeTool === 'SELECT_TOOL')
  const dispatch = useAppDispatch()
  return (
    <ToggleButton fullWidth isSelected={isSelectTool} onChange={() => dispatch(setActiveTool({ tool: 'SELECT_TOOL' }))}>
      <Icon name="select" />
      Select
    </ToggleButton>
  )
}
